import { ISimpleTableField, simpleTableSortFn } from "@asup/simple-table";
import { tocSort } from "contexts/toc/tocSort";
import { ITlfItemRelationship } from "functions/api/tlfItem/TlfItemIndexReadDto";
import { TlfItemTableLinkCell } from "../TlfItemTableLinkCell";

export const TocHeaders: ISimpleTableField[] = [
  {
    name: "tocNumber",
    label: "Number",
    width: "110px",
    // Sort TOC items by number using custom sort function.
    sortFn: (a, b) => tocSort(a.tocNumber as string, b.tocNumber as string),
    // Search TOC items by number, label, or copied-from template ID.
    searchFn: (row, searchText) => {
      const searchTextNormalised = searchText.toLowerCase().trim();
      return (
        ((row.tocNumber as string | undefined)?.toLowerCase().includes(searchTextNormalised) ||
          (row.tocLabel as string | undefined)?.toLowerCase().includes(searchTextNormalised) ||
          (row.tlfCopiedFromLink as ITlfItemRelationship | undefined)?.azsolId
            ?.toLowerCase()
            .includes(searchTextNormalised)) ??
        false
      );
    },
    canColumnFilter: true,
    renderFn: TlfItemTableLinkCell,
  },
  {
    name: "tocLabel",
    label: "Title",
    width: "600px",
    sortFn: simpleTableSortFn,
    canColumnFilter: true,
  },
];
